/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-west-1",
    "aws_appsync_graphqlEndpoint": "https://ubyhauizkncaxjjdclrfnol7ie.appsync-api.eu-west-1.amazonaws.com/graphql",
    "aws_appsync_region": "eu-west-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_cognito_identity_pool_id": "eu-west-1:2ced9e53-6ce8-4b64-86ad-9af237371fb3",
    "aws_cognito_region": "eu-west-1",
    "aws_user_pools_id": "eu-west-1_38zjJNvvw",
    "aws_user_pools_web_client_id": "131g9k0gerinmot3hv3tgpfa21",
    "oauth": {
        "domain": "ngpsselfservicedevauth.auth.eu-west-1.amazoncognito.com"
    },
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": [
            "REQUIRES_LOWERCASE",
            "REQUIRES_UPPERCASE",
            "REQUIRES_NUMBERS",
            "REQUIRES_SYMBOLS"
        ]
    },
    "aws_cognito_verification_mechanisms": [],
    "aws_user_files_s3_bucket": "ngps-private-bucket-alpha",
    "aws_user_files_s3_bucket_region": "eu-west-1"
};


export default awsmobile;
